module.exports = __webpack_public_path__ + "img/CB0030_hamster.7ba03b6d.png";